module.exports = __webpack_public_path__ + "img/jpm_icons4.7594ea37.svg";